export default __webpack_public_path__ + "static/media/pie@2x.f0530d25.png";